import { useExceptions } from "./exceptions.mjs";
import { useIdentity } from "./auth/identity.mjs";
import {
  EnterOtpDocument,
  ResendOtpDocument,
  VerifyCustomerDocument
} from "../graphql/Auth.mjs";
import { extractValue } from "../utils/collections.mjs";
import { isValidOtp } from "../utils/text.mjs";
import { computed, reactive, ref, watch } from "vue";
import { useMutation } from "villus";
import { debounce } from "lodash-es";
export function usePhoneVerification() {
  const phoneVerification = ref("");
  const inputs = reactive({
    input1: "",
    input2: "",
    input3: "",
    input4: ""
  });
  watch(
    inputs,
    debounce((inputValue) => {
      const input = `${inputValue.input1}${inputValue.input2}${inputValue.input3}${inputValue.input4}`;
      if (isValidOtp(input)) {
        phoneVerification.value = input;
      }
    }, 400)
  );
  return { inputs, phoneVerification };
}
export function useVerifyOtp(phoneNumber) {
  const { execute, isFetching: isFetchingOtp } = useMutation(EnterOtpDocument);
  const {
    execute: executeVerifyCustomer,
    isFetching: isFetchingVerifyCustomer
  } = useMutation(VerifyCustomerDocument);
  const { resolveException } = useExceptions("otpVerification");
  const { identify } = useIdentity();
  async function verifyOtp(code, forceLogin = false) {
    try {
      if (forceLogin) {
        const { error } = await executeVerifyCustomer({
          otp: code,
          phoneNumber: extractValue(phoneNumber)
        });
        if (error) {
          throw error;
        }
        if (error && resolveException(error)?.level === "DANGER")
          throw resolveException(error);
      } else {
        const { error } = await execute({
          otp: code,
          phoneNumber: extractValue(phoneNumber)
        });
        if (error) {
          throw error;
        }
        if (error && resolveException(error)?.level === "DANGER")
          throw resolveException(error);
      }
      if (forceLogin) {
        return await identify();
      }
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
  return {
    verifyOtp,
    isFetching: computed(
      () => isFetchingVerifyCustomer.value || isFetchingOtp.value
    )
  };
}
export function useSendVerificationCode(phoneNumber) {
  const { execute, isFetching } = useMutation(ResendOtpDocument);
  async function sendVerificationCode() {
    try {
      const { error } = await execute({ phoneNumber });
      if (error) throw error;
    } catch (e) {
      console.log(e.message);
      throw e;
    }
  }
  async function reSendVerificationCode(phoneNumber2) {
    const { error } = await execute({ phoneNumber: phoneNumber2 });
    if (error) throw error;
  }
  return {
    sendVerificationCode,
    reSendVerificationCode,
    isFetching
  };
}
